import { render, staticRenderFns } from "./QuestionImageHorizontal.vue?vue&type=template&id=ec1bfc0a&scoped=true&lang=pug&"
import script from "./QuestionImageHorizontal.vue?vue&type=script&lang=ts&"
export * from "./QuestionImageHorizontal.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionImageHorizontal.vue?vue&type=style&index=0&id=ec1bfc0a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1bfc0a",
  null
  
)

export default component.exports